module.exports = __webpack_public_path__ + "static/img/7.b64c0c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/7.png
// module id = bzVV
// module chunks = 0